import React from "react";
import PortsIcon from "assets/img/svg/ports.svg?react";
import { CreateFirewallRule } from "components/Environment/Create/ExposePorts";
import { UserIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "@mui/material";

interface ExposedPortsPieceProps {
  ports: Record<string, string> | null;
  firewallRules: CreateFirewallRule[] | null;
}

export const ExposedPortsPiece: React.FC<ExposedPortsPieceProps> = ({
  ports,
  firewallRules,
}) => {
  return (
    <div className="flex flex-col text-sm h-full items-start">
      <div className="flex flex-col  items-center text-gray-500 dark:text-white">
        <div className="flex flex-row mt-[2px] items-center">
          <PortsIcon height={"14px"} width={"32px"} />
          <div className="flex flex-row">
            <span className="text-sm ml-1">Exposed Ports</span>
          </div>
        </div>
        <div className="flex flex-col">
          {ports && Object.keys(ports).length > 0 && (
            <div className="flex flex-row w-full mt-1">
              <span className="text-xs font-bold mr-1">Tunnels:</span>
              <span className="text-xs max-w-[250px]">
                {Object.keys(ports)
                  .map((port) => `${port}:${ports[port]}`)
                  .join(" | ")}
              </span>
            </div>
          )}
          {firewallRules && firewallRules.length > 0 && (
            <div className="flex flex-row w-full mt-1 justify-start">
              <span className="text-xs font-bold mr-1">Firewall Rules:</span>
              <span className="text-xs max-w-[250px] flex flex-row">
                {firewallRules.map((firewallRule, index) => {
                  if (firewallRule.allowedIPs === "user-ip") {
                    return (
                      <>
                        {index > 0 && (
                          <span className="text-xs mr-1">
                            {firewallRule.allowedIPs.length > 0 ? " , " : ""}
                          </span>
                        )}
                        <Tooltip
                          title="Only the user's IP address will be allowed to access this port(s)"
                          placement="top"
                        >
                          <span className="flex flex-row items-start cursor-pointer">
                            <span className="h-[12px] flex flex-row justify-start text-xs">
                              {firewallRule.port}
                            </span>
                            <div className="flex flex-row items-center mt-[2px]">
                              <UserIcon className="w-3 h-3 ml-1" />
                            </div>
                          </span>
                        </Tooltip>
                      </>
                    );
                  } else {
                    return (
                      <>
                        {index > 0 && (
                          <span className="text-xs mr-1">
                            {firewallRule.allowedIPs.length > 0 ? " , " : ""}
                          </span>
                        )}
                        <p className="flex flex-row items-center">
                          {firewallRule.port}
                        </p>
                      </>
                    );
                  }
                })}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
